import { REACT_APP_MDS_URL } from "constants/constants";
import {
  getApiErrorMessage,
  parseFetchResponseBody,
} from "helpers/packageManagementApi";

const buildMappingsUrl = (resourceType) => {
  const baseUrl = REACT_APP_MDS_URL.replace(/\/$/, "");
  return `${baseUrl}/get-all-mappings?resource_type=${encodeURIComponent(resourceType)}`;
};

const normalizeMdsMappingItem = (mappingItem) => {
  if (
    mappingItem === null ||
    mappingItem === undefined ||
    typeof mappingItem !== "object" ||
    Array.isArray(mappingItem)
  ) {
    return mappingItem;
  }

  const { details, ...mappingFields } = mappingItem;

  if (
    details !== null &&
    details !== undefined &&
    typeof details === "object" &&
    !Array.isArray(details)
  ) {
    return {
      ...mappingFields,
      ...details,
      id: mappingItem.id ?? details.id,
    };
  }

  return mappingItem;
};

const extractMdsMappingItems = (responseBody) => {
  if (Array.isArray(responseBody?.items)) {
    return responseBody.items;
  }

  if (Array.isArray(responseBody?.data?.items)) {
    return responseBody.data.items;
  }

  if (Array.isArray(responseBody?.data)) {
    return responseBody.data;
  }

  return [];
};

export const fetchMdsMappings = async (resourceType) => {
  if (REACT_APP_MDS_URL === "" || REACT_APP_MDS_URL === undefined) {
    throw new Error("MDS API URL is not configured.");
  }

  const response = await fetch(buildMappingsUrl(resourceType), {
    method: "POST",
    headers: { accept: "application/json" },
    body: "",
  });

  const responseBody = await parseFetchResponseBody(response);

  if (!response.ok) {
    throw new Error(
      getApiErrorMessage(
        responseBody,
        `Failed to fetch ${resourceType} mappings.`,
        response.status
      )
    );
  }

  return extractMdsMappingItems(responseBody).map(normalizeMdsMappingItem);
};
